export const PATH_TO_USER_TYPE_STATE = "userType";
